import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { cpfValidator } from './cpf.validator';
import { cnpjValidator } from './cnpj.validator';

/**
 * Validator condicional para CPF/CNPJ.
 * Detecta automaticamente pelo comprimento do raw value (sem formatação):
 *   - 11 chars → valida como CPF
 *   - 14 chars → valida como CNPJ alfanumérico
 *   - Outro    → comprimento inválido
 *
 * Uso: documentoValidator() no array de validators do FormControl.
 */
export function documentoValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    // Remove apenas separadores de formatação, preserva alfanuméricos
    const raw = control.value.toString().replace(/[.\-\/]/g, '').trim();

    if (raw.length === 11) {
      return cpfValidator()(control);
    } else if (raw.length === 14) {
      return cnpjValidator()(control);
    } else {
      return { documentoInvalido: true };
    }
  };
}
